import { LoadingWrapper } from "components/common/layouts";
import { FormType } from "enums/form";
import { useError, useHttpQueryService } from "hooks";
import { FeedbackRequestService } from "services";
import ListToDoFeedbackRequests from "components/feedback-request/ToDoList";

const ToDoAnytimeFeedbackRequests = () => {
  const {
    result: feedbackRequests,
    error,
    isLoading,
  } = useHttpQueryService({
    request: () => FeedbackRequestService.getByFormType(FormType.ANYTIME),
  });

  useError(error, true);

  return (
    <LoadingWrapper isLoading={isLoading}>
      <ListToDoFeedbackRequests feedbackRequests={feedbackRequests ?? []} />
    </LoadingWrapper>
  );
};

export default ToDoAnytimeFeedbackRequests;
